import { useTranslation } from 'react-i18next';

export function useI18nLabels() {
  const { t } = useTranslation('translations');

  const frequencyLabelMapper = (value: string): string => {
    const map: Record<string, string> = {
      monthly: t('Global.FrequencyOptions.monthly'),
      weekly: t('Global.FrequencyOptions.weekly'),
      biweekly: t('Global.FrequencyOptions.biweekly'),
      '3 months': t('Global.FrequencyOptions.quarterly'),
      '6 months': t('Global.FrequencyOptions.semiAnnually'),
      yearly: t('Global.FrequencyOptions.annually'),
      bimonthly: t('Global.FrequencyOptions.bimonthly'),
      'semi-monthly': t('Global.FrequencyOptions.semiMonthly'),
      daily: t('Global.FrequencyOptions.daily'),
      single: t('Global.FrequencyOptions.single'),
    };
    return t(map[value] || '');
  };

  const transferTypeLabelMapper = (value: string, defaultLabel?: string): string => {
    const map: Record<string, string> = {
      'fund-transfer': t('Global.TransferTypeOptions.fundTransfer'),
      'transfer-withdraw': t('Global.TransferTypeOptions.transferWithdraw'),
      'fund-transfer-withdraw': t('Global.TransferTypeOptions.fundTransferWithdraw'),
    };
    return t(map[value] ?? defaultLabel ?? t('Global.TransferTypeOptions.fundTransferWithdraw'));
  };

  const semiMonthlyDateLabelMapper = (value: string): string => {
    const map: Record<string, string> = {
      SemiMonthFirstAndFifteenth: t('Global.SemiMonthlyDateOptions.firstAndFifteenth'),
      SemiMonthFifteenthAndLast: t('Global.SemiMonthlyDateOptions.fifteenthAndLast'),
    };
    return t(map[value] || '');
  };

  return {
    frequencyLabelMapper,
    transferTypeLabelMapper,
    semiMonthlyDateLabelMapper,
  };
}
